import React from 'react';
import styled from 'styled-components';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { Flex, mobileCss, MobileFlex } from '@equifinance/shared';

const DocumentContainer = styled(MobileFlex)`
  justify-content: space-around;
  width:100%;
  padding:10vh;
  padding-left:20vw;
  padding-right:20vw;
  ${mobileCss`
    padding:10vw;
  `}
`;

const Download = styled(Flex)` ${({ theme }) => `
  flex-direction:column;
  width:10vw;
  align-items: center;
  padding: ${theme.padding[2]};
  ${mobileCss`
    width:auto;
  `}
`}`;

const Icon = styled.i` ${({ theme }) => `
  color:${theme.textPrimary};
  font-size:${theme.fontSize[11]};
`}`;

const DownloadText = styled.div` ${({ theme }) => `
  font-size: ${theme.fontSize[7]}
`}`;

function DocumentDetails() {
  return (
    <DocumentContainer>
      <Download>
        <FileIcon extension="doc" {...defaultStyles.doc} />
        <DownloadText>Disbursements</DownloadText>
        <Flex>
          <Icon className="mi-email" />
          <Icon className="mi-cloud-download" />
        </Flex>
      </Download>
      <Download>
        <FileIcon extension="pdf" {...defaultStyles.pdf} />
        <DownloadText>ESIS</DownloadText>
        <Flex>
          <Icon className="mi-email" />
          <Icon className="mi-cloud-download" />
        </Flex>
      </Download>
      <Download>
        <FileIcon extension="pdf" {...defaultStyles.pdf} />
        <DownloadText>Other</DownloadText>
        <Flex>
          <Icon className="mi-email" />
          <Icon className="mi-cloud-download" />
        </Flex>
      </Download>
    </DocumentContainer>
  );
}

export default DocumentDetails;
